import EntryActionTypes from '../constants/EntryActionTypes';

const createCardRelation = (cardId, card2Id, type) => ({
  type: EntryActionTypes.CARD_RELATION_CREATE,
  payload: {
    cardId,
    card2Id,
    type,
  },
});

const clearCardRelationCreateError = () => ({
  type: EntryActionTypes.CARD_RELATION_CREATE_ERROR_CLEAR,
  payload: {},
});

const deleteCardRelation = (id) => ({
  type: EntryActionTypes.CARD_RELATION_DELETE,
  payload: {
    id,
  },
});

export default {
  createCardRelation,
  clearCardRelationCreateError,
  deleteCardRelation,
};
